import { useSyncExternalStore } from 'react'
import type { DesignOverflowLevel } from './designOverflowMeasure'

/**
 * «Составной блок переполнен» — уровень (`fits`/`warn`/`over`), который считает холст (`DesignCanvas`,
 * только редактируемый), а показывает панель кнопок под холстом
 * (`DesignOverflowWarning`): плашка поверх экрана перекрывала содержимое.
 */
let level: DesignOverflowLevel = 'fits'
const listeners = new Set<() => void>()

export const setDesignOverflow = (next: DesignOverflowLevel): void => {
  if (level === next) return
  level = next
  listeners.forEach((l) => l())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useDesignOverflow = (): DesignOverflowLevel => useSyncExternalStore(subscribe, () => level)
